import { render } from "./ConcussionAssessment.vue?vue&type=template&id=dfb0e226&scoped=true"
import script from "./ConcussionAssessment.vue?vue&type=script&lang=js"
export * from "./ConcussionAssessment.vue?vue&type=script&lang=js"

import "./ConcussionAssessment.vue?vue&type=style&index=0&id=dfb0e226&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb0e226"]])

export default __exports__